import styles from "./AuthPages.module.css";
import { ReactNode } from "react";

interface Props {
  leftSide: ReactNode;
  rightSide: ReactNode;
}

export function AuthPage(props: Props) {
  return (
    <div className={styles.authPage}>
      <div className={styles.leftSide}>{props.leftSide}</div>
      <div className={styles.rightSide}>{props.rightSide}</div>
    </div>
  );
}
